/** The Subscriber Desk user manual's sections, in order. Ids are linked from the Desk pages (PAGE_HELP): rename one there too. */
export const CONTENTS: [string, string][] = [
  ['start', 'Start here'],
  ['activity', 'Activity'],
  ['find', 'Finding a member'],
  ['batch', 'Mail Order Batches'],
  ['record', 'The member record'],
  ['quick', 'Calls, resends and printing'],
  ['details', 'Editing details'],
  ['enddate', 'Changing an end date'],
  ['payment', 'Recording a payment'],
  ['phone', 'Taking a card by phone'],
  ['gifts', 'Gifts'],
  ['mistakes', 'Fixing mistakes'],
  ['access', 'Giving someone access'],
  ['faq', 'Questions and problems'],
]

/** The manual section each Desk page's "How this works" link opens. */
export const PAGE_HELP = {
  activity: 'activity',
  find: 'find',
  member: 'record',
  pay: 'payment',
  batch: 'batch',
} as const
